var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Circled1Yellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffe70d",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,4c-11.046,0 -20,8.954 -20,20c0,11.046 8.954,20 20,20c11.046,0 20,-8.954 20,-20c0,-11.046 -8.954,-20 -20,-20zM24,7c9.374,0 17,7.626 17,17c0,9.374 -7.626,17 -17,17c-9.374,0 -17,-7.626 -17,-17c0,-9.374 7.626,-17 17,-17zM24.41406,14.00195c-0.11597,0.00659 -0.23195,0.0268 -0.3457,0.06055l-5,1.5c-0.793,0.238 -1.24386,1.07614 -1.00586,1.86914c0.238,0.793 1.07114,1.24291 1.86914,1.00391l3.06836,-0.91992v14.98438c0,0.829 0.671,1.5 1.5,1.5c0.829,0 1.5,-0.672 1.5,-1.5v-17c0,-0.475 -0.22447,-0.92013 -0.60547,-1.20312c-0.28575,-0.21225 -0.63256,-0.3147 -0.98047,-0.29492z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Circled1Yellow);
export default __webpack_public_path__ + "static/media/icons8-circled-1-yellow.cee2ed9b02db36ece48e83232599bc06.svg";
export { ForwardRef as ReactComponent };